import axios from 'axios';
import { DigitalSignatureModel, SignerModel } from 'app/shared/digital-signature/digital-signature.model';

export const digitalSignature = async (
  entity: string,
  idEntity: number,
  signatureEnum: number,
  currentUrl: string,
): Promise<DigitalSignatureModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/esign/${entity}/${idEntity}/${signatureEnum}?url=${currentUrl}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchSigners = async (entity: string, idEntity: number): Promise<SignerModel[]> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/esign/signers/${entity}/${idEntity}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};
